import { EMPTY, Observable, switchMap } from "rxjs";

export function switchEnable<T,O extends Observable<any>>(next:O){
	return switchMap<T,O|Observable<never>>(
		(input:T)=>{
			if(!input)
				return EMPTY;
			return next;
		}
	);
}
